import outputs from '@/__generated__/amplify_outputs.json';
import { CredentialsAndIdentityId } from '@aws-amplify/core';
import {
  CognitoIdentityClient,
  GetCredentialsForIdentityCommand,
  GetIdCommand
} from '@aws-sdk/client-cognito-identity';

const cognitoIdentityClient = new CognitoIdentityClient({
  region: outputs.auth.aws_region
});

export async function getCredentialsAndIdentityId(
  idToken?: string
): Promise<CredentialsAndIdentityId | undefined> {
  const domain = `cognito-idp.${outputs.auth.aws_region}.amazonaws.com/${outputs.auth.user_pool_id}`;

  const { IdentityId } = await cognitoIdentityClient.send(
    new GetIdCommand({
      IdentityPoolId: outputs.auth.identity_pool_id,
      ...(idToken ? { Logins: { [domain]: idToken } } : {})
    })
  );

  const { Credentials } = await cognitoIdentityClient.send(
    new GetCredentialsForIdentityCommand({
      IdentityId,
      ...(idToken ? { Logins: { [domain]: idToken } } : {})
    })
  );

  if (
    !Credentials?.AccessKeyId ||
    !Credentials?.SecretKey ||
    !Credentials.Expiration
  )
    return undefined;

  return {
    credentials: {
      accessKeyId: Credentials.AccessKeyId,
      secretAccessKey: Credentials.SecretKey,
      sessionToken: Credentials.SessionToken,
      expiration: new Date(Credentials.Expiration)
    },
    identityId: IdentityId
  };
}
